import userRole from './userRole';

const adminUserRoles = [
    userRole.admin,
    userRole.localAdmin
];

export default adminUserRoles;
